import ModelPriceSummary from './ModelPriceSummary';
import { vehiclePrices } from './vehiclePrices';
import React, { useRef, useEffect, useState } from 'react';
import img1 from './Asset/no1.jpg';
import img2 from './Asset/no2.jpg';
import img3 from './Asset/no3.jpg';
import img4 from './Asset/no4.jpg';
import img5 from './Asset/no5.jpg';
import img6 from './Asset/no6.jpg';
import img7 from './Asset/no7.jpg';
import img8 from './Asset/no8.jpg';
import banner from './Asset/banner.webp';
import { Box, Typography, Button, useMediaQuery } from '@mui/material';
import brochure from './Asset/SEAL-BROCHURE.pdf';
import PageSeo, {
  breadcrumbJsonLd,
  keywordSets,
  productJsonLd,
} from './PageSeo';

function JelajahiSeal() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const sections = useRef([]);
  const [visibleSections, setVisibleSections] = useState({});

  const images = [
    {
      src: banner,
      title: 'BYD SEAL',
      specs: [
        { value: '2026', label: 'NIK' },
        { value: 'Baterai baru', label: 'Baterai' },
        { value: '1 varian', label: 'Pilihan' },
        { value: vehiclePrices.seal[0].price, label: 'Harga' },
      ],
    },
    {
      src: img1,
      title: 'Tim Desainer Kelas Internasional',
      description: `Dipimpin oleh Kepala Desainer Otomotif Wolfgang Egger, tim desain kelas dunia mengintegrasikan inovasi dengan kualitas dan keandalan dalam kreasi otomotif mereka.`,
    },
    {
      src: img2,
      title: 'Estetika Laut',
      description: `BYD SEAL dibangun berdasarkan konsep desain "estetika laut". Proporsi bodi yang eksklusif berasal dari perburuan keindahan.`,
    },
    {
      src: img3,
      title: 'Postur yang mempesona',
      description: `Postur yang mempesona mencuri perhatian ketika mobil berada di depan. Lampu belakang berbentuk kisi seperti tetesan air yang jatuh ke dalam air, menciptakan lapisan cahaya berkilauan.`,
    },
    {
      src: img4,
      title: 'Teknologi Baterai Blade Berpaten Ultra-Aman',
      description: `Selama menjalani uji penetrasi paku, Baterai Blade tidak mengeluarkan asap atau api setelah ditembus, dan suhunya hanya mencapai 30 hingga 60°C.`,
    },
    {
      src: img5,
      title: 'Teknologi CTB (Cell-to-Body)',
      description: `Penutup atas baterai dan lantai bodi digabungkan menjadi satu, membentuk struktur "sandwich" dari seluruh kendaraan.`,
    },
    {
      src: img6,
      title: 'Sistem iTAC (Intelligence Torque Adaption Control)',
      description: `Berdasarkan respons cepat motor listrik, sensor digunakan untuk mengidentifikasi dengan cepat perubahan status kendaraan.`,
    },
    {
      src: img7,
      title: 'Wishbone Ganda + Banyak-Link',
      description: `Konfigurasi suspensi tingkat tinggi menciptakan pengalaman berkendara ultimate.`,
    },
    {
      src: img8,
      title: 'BYD SEAL',
    },
  ];

  const filteredImages = isMobile
    ? images.filter((img) => img.src !== img7)
    : images;

  useEffect(() => {
    const currentSections = sections.current;

    const observer = new IntersectionObserver(
      (entries) => {
        setVisibleSections((prev) => {
          const updated = { ...prev };
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updated[entry.target.dataset.index] = true;
            }
          });
          return updated;
        });
      },
      { threshold: 0.5 },
    );

    currentSections.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      currentSections.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <Box component='main' sx={{ pt: { xs: 10, md: 12 } }}>
      <PageSeo
        title='BYD Seal NIK 2026 | Baterai Baru Rp869 Juta'
        description='BYD Seal NIK 2026 dengan baterai baru, satu varian seharga Rp869 juta. Konsultasi pembelian, promo, dan test drive bersama Junius di BYD BSD Serpong.'
        keywords={[
          ...keywordSets.localDealer,
          'harga BYD Seal BSD',
          'BYD Seal Tangerang',
          'sedan listrik BYD',
          'BYD Seal baterai baru 2026',
        ]}
        path='/jelajahi-seal'
        image={banner}
        jsonLd={[
          productJsonLd({
            name: 'BYD Seal',
            description:
              'Sedan listrik BYD Seal NIK 2026 dengan baterai baru, tersedia satu varian seharga Rp869 juta.',
            image: banner,
            path: '/jelajahi-seal',
            lowPrice: vehiclePrices.seal[0].priceValue,
            highPrice: vehiclePrices.seal[0].priceValue,
            offerCount: 1,
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'BYD Seal', path: '/jelajahi-seal' },
          ]),
        ]}
      />
      <Typography
        variant='h1'
        component='h1'
        sx={{
          fontSize: { xs: '2rem', sm: '3rem' },
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: 4,
          marginTop: 2,
        }}
      >
        Jelajahi BYD Seal
      </Typography>
      <ModelPriceSummary model='BYD Seal' priceKey='seal' />
      {filteredImages.map((img, index) => (
        <Box
          key={index}
          ref={(el) => (sections.current[index] = el)}
          data-index={index}
          sx={{
            position: 'relative',
            height: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <Box
            component='img'
            src={img.src}
            alt={`Image ${index + 1}`}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1,
            }}
          />

          {img.title && (
            <Box
              sx={{
                position: 'absolute',
                top: { xs: '10%', sm: '15%' },
                color: img.src === img1 || img.src === img7 ? '#000' : '#fff', // Black for img2 and img7
                textAlign: 'center',
                padding: 2,
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='h4'
                fontWeight='bold'
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}
              >
                {img.title}
              </Typography>
            </Box>
          )}

          {img.specs && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '10%', sm: '5%' },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'center',
                gap: { xs: 2, sm: 4 },
                color: '#fff',
              }}
            >
              {img.specs.map((spec, i) => (
                <React.Fragment key={i}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      sx={{
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                      }}
                    >
                      {spec.value}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                      }}
                    >
                      {spec.label}
                    </Typography>
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          )}

          {img.description && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '15%', sm: '10%' },
                color: '#fff',
                textAlign: 'center',
                padding: 2,
                maxWidth: { xs: '90%', sm: '80%' },
                background: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='body1'
                fontWeight='400'
                lineHeight='1.5'
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                }}
              >
                {img.description}
              </Typography>
            </Box>
          )}
          {img.src === img8 && (
            <Button
              href={brochure}
              download='SEAL-BROCHURE.pdf'
              variant='outlined'
              sx={{
                position: 'absolute',
                bottom: '10%',
                borderColor: '#fff',
                color: '#fff',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                fontWeight: 600,
                padding: { xs: '8px 16px', sm: '10px 20px' },
                '&:hover': {
                  backgroundColor: '#fff',
                  color: '#000',
                },
              }}
            >
              Download Brosur
            </Button>
          )}
        </Box>
      ))}
      <Box
        sx={{
          padding: { xs: 3, sm: 6 },
          backgroundColor: '#f4f4f4',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            borderRadius: 2,
            boxShadow: 3,
            padding: { xs: 3, sm: 4 },
            maxWidth: 700,
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Typography
            variant='h3'
            sx={{
              fontSize: { xs: '1.5rem', sm: '2rem' },
              fontWeight: 700,
              mb: 2,
            }}
          >
            🚗 Tertarik dengan BYD SEAL?
          </Typography>

          <Typography variant='body1' sx={{ mb: 2 }}>
            Dapatkan <strong>Harga BYD SEAL</strong> terbaik langsung dari{' '}
            <strong>Dealer Resmi BYD BSD Serpong</strong>.
          </Typography>

          <Typography variant='body2' sx={{ mb: 2 }}>
            Kami juga siap membantu Anda dengan informasi lengkap mengenai:
          </Typography>

          <Box
            component='ul'
            sx={{
              textAlign: 'left',
              maxWidth: 500,
              margin: '0 auto 16px auto',
              paddingLeft: 2,
            }}
          >
            <li>
              <Typography variant='body2'>
                ✅ <strong>Harga Danza D9</strong> lengkap semua varian
              </Typography>
            </li>
            <li>
              <Typography variant='body2'>
                ✅ <strong>Harga Sealion 7</strong> & promo cicilan ringan
              </Typography>
            </li>
            <li>
              <Typography variant='body2'>
                ✅ <strong>Harga Atto1</strong> mobil listrik ekonomis terbaru
              </Typography>
            </li>
          </Box>

          <Button
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20dengan%20BYD%20SEAL%20dan%20ingin%20tahu%20harganya'
            target='_blank'
            variant='contained'
            color='primary'
            sx={{
              fontWeight: 600,
              fontSize: '1rem',
              paddingX: 4,
              paddingY: 1.5,
            }}
          >
            Tanya Harga via WhatsApp
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default JelajahiSeal;
